import React from "react";
export default function IndustriesServed() {
  return null;
}